import React from 'react';
import { IconSvgProps } from '@models/common';

const CheckedList: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13 5L22 5M13 12L22 12M13 19H22'
        stroke='#292929'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M7.98303 3.49121L4.87483 6.50966L3.16992 4.90692'
        stroke='#0DB49C'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.98303 10.5088L4.87483 13.5272L3.16992 11.9245'
        stroke='#0DB49C'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.98303 17.5273L4.87483 20.5458L3.16992 18.9431'
        stroke='#0DB49C'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CheckedList;
